import PdfArticulosButton from 'components/Articulos/ArticulosPanel/PdfArticulosButton'
import ArticulosTable from 'components/ArticulosTable/ArticulosTable'
import BuscadorArticulos from 'components/ArticulosTable/BuscadorArticulos'
import { ArticulosTablePageProvider } from 'context/ArticulosTablePageContext'
import ArticulosFilter from 'components/ArticulosTable/ArticulosFilter'

function Articulos() {
  return (
    <ArticulosTablePageProvider>
      <div className="articulos-page-container">
        <div className="articulos-page-container-header">
          <BuscadorArticulos />
          <ArticulosFilter  />
          <PdfArticulosButton />
        </div>
        <ArticulosTable />
      </div>
    </ArticulosTablePageProvider>
  )
}
export default Articulos
